import React, { useEffect, useRef } from 'react';
import { Grid, Button } from '@inplayer-org/inplayer-ui';

// components
import PanoptoForm from 'pages/MerchantPages/Assets/Content/components/FormikFields/Panopto/PanoptoForm';
import StyledContainer from 'components/StyledContainer';

// hooks
import useIframe from 'hooks/useIframe';

// constants
import { API } from 'constants/api';
import Restricted from 'restrictions/roles/components/Restricted';
import useRestrictionRules from 'restrictions/roles/hooks/useRestrictionRules';
import Rules from 'restrictions/roles/constants/rules';

const { Cell } = Grid;

type PanoptoContentObject = Record<string, any>;

interface Props {
  value: PanoptoContentObject;
  switchToVideoBrowsing: () => void;
}

const VideoView = ({ value, switchToVideoBrowsing }: Props) => {
  const formRef = useRef<HTMLFormElement>(null);

  const { isLoading, isLoaded, startLoading, onLoad } = useIframe();

  useEffect(() => {
    const { current: form } = formRef;

    if (form) {
      startLoading();
      form.submit();
    }
  }, []);

  const { hasRule } = useRestrictionRules();
  const isReadOnly = hasRule(Rules.READONLY_ASSETS_AND_PACKAGES);

  return (
    <>
      {isLoaded && (
        <StyledContainer margin="0 0 1rem 0" columns={1}>
          <Cell>
            <Restricted isRestricted={isReadOnly}>
              <Button type="button" onClick={switchToVideoBrowsing}>
                Choose another video...
              </Button>
            </Restricted>
          </Cell>
        </StyledContainer>
      )}
      <PanoptoForm
        formRef={formRef}
        isLoading={isLoading}
        action={API.PANOPTO_VIDEO}
        formdata={value}
        onLoad={onLoad}
      />
    </>
  );
};

export default VideoView;
